import React, { Component } from "react";
import { Row, Table, Tag, Input, Select, Button, message, Tooltip } from "antd";
import { BulbOutlined, CalendarOutlined, StopOutlined, UndoOutlined, ThunderboltOutlined, TableOutlined, PlayCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { DynamicCardForm, ButtonItem, SegmentedItem } from "../../../../Components/Items";
import CalendarioCMMS, { LeyendaCMMS } from "../componentes/CalendarioCMMS";
import DrawerPlanCMMS from "../componentes/DrawerPlanCMMS";
import ModalCalendarizarCMMS from "../componentes/ModalCalendarizarCMMS";
import ModalNoRealizadoCMMS from "../componentes/ModalNoRealizadoCMMS";
import ModalSugerirCMMS from "../componentes/ModalSugerirCMMS";
import { calendarizarPlanes, noRealizarPlanes, reactivarPlanes } from "../componentes/accionesPlanes";
import { cmmsPost, ESTATUS_PLAN, estatusPlan, formatoFecha } from "../cmmsComun";
import ModalDistribuirCMMS from "./ModalDistribuirCMMS";
import "../cmms.css";

const { Option } = Select;

// Calendarizacion del contrato: el programa completo (como el Planeador), en tabla o en
// calendario. Se reparte automaticamente y se ajusta a mano. Nada de aqui crea servicios.
// Sin filtro de ingeniero (ni el fijado con la chincheta): al calendarizar lo que queda para otro
// ingeniero o para todos desaparecia de la vista y parecia que el sistema no habia hecho nada.
class CalendarizacionContrato extends Component {
    state = {
        cargando: false,
        planes: [],
        vista: "tabla",
        vueltaId: null,
        estatus: null,
        texto: "",
        seleccion: [],
        plan: null,
        modalDistribuir: false,
        modalCalendarizar: false,
        modalNoRealizado: false,
        modalSugerir: false,
        // Permiso "Mover en la agenda": sin el, lo que ya tiene fecha no se arrastra ni se reprograma.
        puedeMover: true,
    };

    componentDidMount() {
        this.consultar();
    }

    componentDidUpdate(prev) {
        if (prev.recarga !== this.props.recarga) this.consultar();
    }

    consultar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "planesContratoCMMS", { contratoId: this.props.contrato._id, vueltaId: this.state.vueltaId });
            if (res.data.success === 2)
                this.setState((s) => ({
                    planes: res.data.planes,
                    puedeMover: res.data.puedeMover !== false,
                    seleccion: s.seleccion.filter((id) => res.data.planes.some((p) => p._id === id)),
                    plan: s.plan ? res.data.planes.find((p) => p._id === s.plan._id) || null : null,
                }));
            else message.error(res.data.message || "No se pudo consultar el programa");
        } finally {
            this.setState({ cargando: false });
        }
    };

    filtrar = (cambios) => this.setState({ ...cambios, seleccion: [] }, this.consultar);

    visibles = () => {
        const t = this.state.texto.trim().toLowerCase();
        return this.state.planes.filter(
            (p) =>
                (!this.state.estatus || p.estatusVisible === this.state.estatus) &&
                (!t || [p.activoTexto, p.sucursalNombre, p.activo?.ubicacion, p.activo?.area, p.folioExterno, p.empleadoNombre].some((x) => String(x || "").toLowerCase().includes(t)))
        );
    };

    terminar = (ok) => {
        if (!ok) return;
        this.setState({ modalCalendarizar: false, modalNoRealizado: false, modalSugerir: false, seleccion: [] }, this.consultar);
    };

    // Sin fecha, pendiente y sin Orden: es una sugerencia (para todos o para un ingeniero).
    esSugerencia = (p) => p.estatus === 1 && !p.fechaPlaneada && !p.servicioId;

    render() {
        const { contrato, bloqueado } = this.props;
        const lista = this.visibles();
        const sel = this.state.seleccion;
        const seleccionados = this.state.planes.filter((p) => sel.includes(p._id));
        // Solo los que aun no tienen fecha (ni Orden) se pueden sugerir.
        const sugeribles = seleccionados.filter(this.esSugerencia);
        const conteo = {};
        this.state.planes.forEach((p) => (conteo[p.estatusVisible] = (conteo[p.estatusVisible] || 0) + 1));
        const eventos = lista
            .filter((p) => p.fechaPlaneada)
            .map((p) => ({
                id: p._id,
                plan: p,
                title: [p.activo?.codigo, p.tipoNombre].filter(Boolean).join(" · "),
                subtitulo: [p.sucursalNombre, p.empleadoNombre || (p.estatus === 1 && !p.servicioId ? "Para todos" : "")].filter(Boolean).join(" · "),
                detalle: `${estatusPlan(p.estatusVisible).label} · ${p.vueltaNombre}`,
                start: moment(String(p.fechaPlaneada).slice(0, 10)).toDate(),
                end: moment(String(p.fechaPlaneada).slice(0, 10)).toDate(),
                color: estatusPlan(p.estatusVisible).hex,
                arrastrable: !bloqueado && this.state.puedeMover && ((p.estatus === 1 && !p.servicioId) || p.estatus === 3),
            }));
        // Sin permiso para mover: si la seleccion trae algo con fecha, solo se le cambia el ingeniero.
        const fechaFija = !this.state.puedeMover && seleccionados.some((p) => p.fechaPlaneada);
        const primeraFecha = lista.find((p) => p.fechaPlaneada)?.fechaPlaneada;
        return (
            <Row gutter={14}>
                <DynamicCardForm
                    title="Programa de servicios"
                    xs={24}
                    headerRight={
                        <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
                            <SegmentedItem
                                options={[
                                    { label: <span><TableOutlined /> Tabla</span>, value: "tabla" },
                                    { label: <span><CalendarOutlined /> Calendario</span>, value: "calendario" },
                                ]}
                                value={this.state.vista}
                                onChange={(vista) => this.setState({ vista })}
                            />
                            {!bloqueado && (
                                <ButtonItem type="primary" size="small" icon={<ThunderboltOutlined />} onClick={() => this.setState({ modalDistribuir: true })}>
                                    Distribuir automáticamente
                                </ButtonItem>
                            )}
                        </span>
                    }
                >
                    <div className="cmms-ayuda">

                        Cada renglón es "a este equipo le toca este servicio en esta vuelta". Póngales fecha e ingeniero (a mano o con Distribuir automáticamente); la Orden de Servicio se crea hasta que se realiza, desde aquí o desde la Agenda. Los que
                        aún no tienen fecha se pueden sugerir a un ingeniero o a todos: filtre “Por calendarizar”, selecciónelos y use “Sugerir a…”.
                    </div>
                    <div className="cmms-chips-estatus">
                        {Object.keys(ESTATUS_PLAN).map((k) => (
                            <span
                                key={k}
                                className={`cmms-chip-estatus ${this.state.estatus === k ? "activo" : ""}`}
                                onClick={() => this.setState({ estatus: this.state.estatus === k ? null : k, seleccion: [] })}
                                style={{ borderColor: ESTATUS_PLAN[k].hex }}
                            >
                                <span className="cmms-cal-chip-punto" style={{ background: ESTATUS_PLAN[k].hex }} />
                                {ESTATUS_PLAN[k].label} <b>{conteo[k] || 0}</b>
                            </span>
                        ))}
                    </div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 8 }}>
                        <Select allowClear placeholder="Todas las vueltas" style={{ width: 200 }} value={this.state.vueltaId || undefined} onChange={(vueltaId) => this.filtrar({ vueltaId: vueltaId || null })}>
                            {(contrato.vueltas || []).map((v) => (
                                <Option key={v._id} value={v._id}>
                                    {v.nombre}
                                </Option>
                            ))}
                        </Select>
                        <Input.Search placeholder="Buscar equipo, sucursal, folio..." allowClear style={{ width: 260 }} value={this.state.texto} onChange={(e) => this.setState({ texto: e.target.value })} />
                        {sel.length > 0 && !bloqueado && (
                            <span className="cmms-barra-seleccion">
                                <b>{sel.length} seleccionados</b>
                                <Button size="small" type="primary" icon={<CalendarOutlined />} onClick={() => this.setState({ modalCalendarizar: true })}>
                                    {fechaFija ? "Cambiar ingeniero" : "Calendarizar / reprogramar"}
                                </Button>
                                <Tooltip title="Sugerir a un ingeniero (o a todos) los que todavía no tienen fecha">
                                    <Button size="small" icon={<BulbOutlined />} onClick={() => this.setState({ modalSugerir: true })}>
                                        Sugerir a...
                                    </Button>
                                </Tooltip>
                                <Button size="small" danger icon={<StopOutlined />} onClick={() => this.setState({ modalNoRealizado: true })}>
                                    No realizado
                                </Button>
                                {seleccionados.some((p) => p.estatus === 3) && (
                                    <Button size="small" icon={<UndoOutlined />} onClick={async () => this.terminar(await reactivarPlanes(this.props, sel))}>
                                        Reactivar
                                    </Button>
                                )}
                            </span>
                        )}
                    </div>
                    {this.state.vista === "tabla" ? (
                        <Table
                            size="small"
                            rowKey="_id"
                            loading={this.state.cargando}
                            dataSource={lista}
                            pagination={{ pageSize: 100, showSizeChanger: true, pageSizeOptions: ["50", "100", "200", "500"], size: "small", showTotal: (t) => `${t} renglón(es)` }}
                            scroll={{ x: 1250 }}
                            rowSelection={{ selectedRowKeys: sel, onChange: (seleccion) => this.setState({ seleccion }), preserveSelectedRowKeys: true }}
                            onRow={(r) => ({ onDoubleClick: () => this.setState({ plan: r }) })}
                            locale={{ emptyText: this.state.planes.length ? "Nada coincide con el filtro" : "El programa está vacío: agregue equipos en el paso Equipos." }}
                            columns={[
                                { title: "Fecha", dataIndex: "fechaPlaneada", width: 115, render: (v) => (v ? formatoFecha(v) : <span style={{ color: "#9aa7b4" }}>Sin fecha</span>) },
                                {
                                    title: "Equipo",
                                    dataIndex: "activoTexto",
                                    width: 300,
                                    render: (v, r) => (
                                        <Button type="link" size="small" style={{ padding: 0, height: "auto", whiteSpace: "normal", textAlign: "left" }} onClick={() => this.setState({ plan: r })}>
                                            {v}
                                        </Button>
                                    ),
                                },
                                { title: "Sucursal", dataIndex: "sucursalNombre", width: 190 },
                                { title: "Ubicación", width: 150, render: (r) => [r.activo?.ubicacion, r.activo?.area].filter(Boolean).join(" · ") },
                                { title: "Vuelta", dataIndex: "vueltaNombre", width: 110 },
                                {
                                    title: "Ingeniero",
                                    dataIndex: "empleadoNombre",
                                    width: 170,
                                    render: (v, r) =>
                                        v ? (
                                            this.esSugerencia(r) ? <Tooltip title="Sugerido a este ingeniero (aún sin fecha)">{v} <BulbOutlined style={{ color: "#d9962b" }} /></Tooltip> : v
                                        ) : (
                                            <span style={{ color: "#9aa7b4" }}>{r.estatus === 1 && !r.servicioId ? "Para todos" : "Sin asignar"}</span>
                                        ),
                                },
                                { title: "Folio externo", dataIndex: "folioExterno", width: 150 },
                                {
                                    title: "Estatus",
                                    dataIndex: "estatusVisible",
                                    width: 140,
                                    render: (v, r) => (
                                        <Tooltip title={r.motivoNoRealizado || ""}>
                                            <Tag color={estatusPlan(v).color}>{r.servicioCodigo ? `${estatusPlan(v).label} · ${r.servicioCodigo}` : estatusPlan(v).label}</Tag>
                                        </Tooltip>
                                    ),
                                },
                                {
                                    title: "",
                                    width: 60,
                                    fixed: "right",
                                    render: (r) =>
                                        r.estatus === 1 && !r.servicioId && !bloqueado ? (
                                            <Tooltip title="Iniciar servicio">
                                                <ButtonItem type="default" size="small" cyan icon={<PlayCircleOutlined />} onClick={() => this.props.history.push("/panel/cmmsServicio", { planId: r._id })} />
                                            </Tooltip>
                                        ) : null,
                                },
                            ]}
                        />
                    ) : (
                        <CalendarioCMMS
                            events={eventos}
                            fechaInicial={primeraFecha ? String(primeraFecha).slice(0, 10) : undefined}
                            alto={680}
                            onMover={bloqueado || !this.state.puedeMover ? null : async (e, fecha) => (await calendarizarPlanes(this.props, [e.plan._id], { fecha, cambiarEmpleado: false })) && this.consultar()}
                            onSeleccionar={(e) => this.setState({ plan: e.plan })}
                            leyenda={<LeyendaCMMS items={["calendarizado", "atrasado", "enProceso", "realizado", "noRealizado"].map((k) => ({ label: ESTATUS_PLAN[k].label, hex: ESTATUS_PLAN[k].hex }))} />}
                        />
                    )}
                </DynamicCardForm>

                <ModalDistribuirCMMS
                    {...this.props}
                    puedeMover={this.state.puedeMover}
                    visible={this.state.modalDistribuir}
                    onClose={(aplicado) => this.setState({ modalDistribuir: false }, () => aplicado && this.consultar())}
                />
                <DrawerPlanCMMS
                    {...this.props}
                    bloqueado={bloqueado}
                    puedeMover={this.state.puedeMover}
                    visible={!!this.state.plan}
                    plan={this.state.plan}
                    onClose={() => this.setState({ plan: null })}
                    onCambio={(soloTexto) => this.setState(soloTexto ? {} : { plan: null }, this.consultar)}
                />
                <ModalCalendarizarCMMS
                    {...this.props}
                    visible={this.state.modalCalendarizar}
                    titulo={fechaFija ? "Cambiar ingeniero" : "Calendarizar / reprogramar"}
                    cantidad={sel.length}
                    fechaInicial={sel.length === 1 ? seleccionados[0]?.fechaPlaneada : null}
                    empleadoInicial={sel.length === 1 ? seleccionados[0]?.empleadoId : null}
                    fechaBloqueada={fechaFija}
                    permitirQuitarFecha
                    rango={[String(contrato.fechaInicio).slice(0, 10), String(contrato.fechaConclusion).slice(0, 10)]}
                    onCancel={() => this.setState({ modalCalendarizar: false })}
                    onAceptar={async (d) => this.terminar(await calendarizarPlanes(this.props, sel, d))}
                />
                <ModalSugerirCMMS
                    {...this.props}
                    visible={this.state.modalSugerir}
                    cantidad={sugeribles.length}
                    planesIds={sugeribles.map((p) => p._id)}
                    nota={
                        !sugeribles.length
                            ? "Ninguno de los seleccionados está sin fecha: ya están calendarizados (o realizados). Para cambiarles el ingeniero use “Calendarizar / reprogramar”. Para ver los que faltan, filtre “Por calendarizar”."
                            : sugeribles.length < sel.length
                            ? `Se sugieren ${sugeribles.length} de ${sel.length}: los demás ya tienen fecha o están realizados (para cambiarles el ingeniero use “Calendarizar / reprogramar”).`
                            : null
                    }
                    empleadoInicial={sel.length === 1 ? seleccionados[0]?.empleadoId : null}
                    onCancel={() => this.setState({ modalSugerir: false })}
                    onListo={() => this.terminar(true)}
                />
                <ModalNoRealizadoCMMS
                    visible={this.state.modalNoRealizado}
                    cantidad={sel.length}
                    motivos={this.props.motivos}
                    onCancel={() => this.setState({ modalNoRealizado: false })}
                    onAceptar={async (motivo) => this.terminar(await noRealizarPlanes(this.props, sel, motivo))}
                />
            </Row>
        );
    }
}

export default CalendarizacionContrato;
